<template>
  <div id="qrimage">
    <vue-qrcode v-if="loginUrl" :value="loginUrl" :options="option" tag="img"></vue-qrcode>
    <dl>
      <dt>ユーザー名</dt>
      <dd>{{uid}}</dd>
    </dl>
    <dl>
      <dt>パスワード</dt>
      <dd>{{password}}</dd>
    </dl>
  </div>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
export default {
  components: {
    VueQrcode
  },
  props: ["loginUrl", "uid", "password"],
  data() {
    return {
      option: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 10,
        scale: 2,
        width: 300,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF"
        }
      }
    }
  }
}
</script>

<style scoped>
#qrimage {
  text-align: center;
}
dl {
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 5px;
}
dt {
  width: 130px;
  flex-basis: 130px;
}
dd {
  flex: 1;
  margin-bottom: 0;
  font-size: 25px;
}
</style>